import { differenceInDays } from 'date-fns';

export function daysBetweenDates(d1: Date | number, d2: Date | number) {
  return differenceInDays(d1, d2);
}
